import { Button } from 'cpool-components/input/Button';
import { useTranslation } from 'react-i18next';
import { BsPlus } from 'react-icons/bs';

type Props = {
    onClick: () => void;
    translationPath: string;
    testId?: string;
    disabled?: boolean;
};

const ItemAddButton: React.FC<Props> = ({ disabled, onClick, testId, translationPath }) => {
    const { t } = useTranslation();
    return (
        <div className="flex justify-center pt-1">
            <Button type="button" variant="secondary" onClick={onClick} disabled={disabled}>
                <BsPlus data-testid={testId} size={20} className="-mr-1" />
                {
                    // @ts-expect-error typescript doesn't recognize dynamic values
                    t(translationPath)
                }
            </Button>
        </div>
    );
};

export default ItemAddButton;
